import React from "react";
import styled from "styled-components";
import {useLocation} from 'react-router-dom';

const ReceiverSoftware = (props) => {
  const { onClick, label } = props.data;
  // show ReceiverSoftware in dashboard and hide in all app routes 
  // Lamiaa
  const { pathname } = useLocation();
  console.log(pathname);
  if (pathname === "/layout") {
    return <ReceiverBtn onClick={onClick}>{label}</ReceiverBtn>;
  };

};

export default ReceiverSoftware;

const ReceiverBtn = styled.button`
  background-color: var(--white);
  color: var(--orange);
  border: 1px solid var(--orange);
  padding: 10px;
  font-size: 1em;
  min-width:150px;
  border-radius: 30px;
  cursor: pointer;
  &:hover {
    transform: scale(0.95);
    transition: all 0.5s ease-in-out;
  }
  @media (max-width: 768px) {
     padding: 10px ;
  }
`;
